import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";
function AppLayout() {
  return (
    <>
      <Toaster position="top-right" />
      <Header />
      <div>
        <Outlet />
      </div>
    </>
  );
}

export default AppLayout;
